<main class="site-shell">
  <app-site-header
    (inquiryRequested)="openInquiry()"
    (pageSelected)="showPage($event)"
  />

  @if (activePage() === 'home') {
    <app-home-page
      [blogError]="blogError()"
      [blogLoading]="blogLoading()"
      [blogPosts]="homepageBlogPosts()"
      [propertiesError]="propertiesError()"
      [propertiesLoading]="propertiesLoading()"
      [projects]="homepageProjects()"
      (homeSectionSelected)="showHomeSection($event)"
      (inquiryRequested)="openInquiry()"
      (blogPostSelected)="openBlogPost($event)"
      (pageSelected)="showPage($event)"
      (projectSelected)="openProject($event)"
    />
  } @else if (activePage() === 'about') {
    <app-about-page
      (inquiryRequested)="openInquiry()"
    />
  } @else if (activePage() === 'developments') {
    <app-developments-page
      [propertiesError]="propertiesError()"
      [propertiesLoading]="propertiesLoading()"
      [projects]="projects()"
      (inquiryRequested)="openInquiry()"
      (projectSelected)="openProject($event)"
    />
  } @else if (activePage() === 'project') {
    @if (selectedProject(); as project) {
      <app-project-page
        [project]="project"
      />
    }
  } @else if (activePage() === 'insights') {
    <app-insights-page
      [blogError]="blogError()"
      [blogLoading]="blogLoading()"
      [blogPosts]="blogPosts()"
      (blogPostSelected)="openBlogPost($event)"
    />
  } @else if (activePage() === 'blog-detail') {
    @if (selectedBlogPost(); as post) {
      <app-blog-detail-page
        [error]="blogDetailError()"
        [loading]="blogDetailLoading()"
        [post]="post"
        (backRequested)="showPage('insights')"
      />
    }
  } @else if (activePage() === 'content') {
    <app-content-page
      [contentTab]="contentTab()"
      [youtubeError]="youtubeError()"
      [youtubeLoading]="youtubeLoading()"
      [youtubeVideos]="youtubeVideos()"
      (contentTabSelected)="showContentTab($event)"
      (inquiryRequested)="openInquiry()"
    />
  } @else if (activePage() === 'privacy-policy') {
    <app-legal-page page="privacy" />
  } @else if (activePage() === 'terms') {
    <app-legal-page page="terms" />
  } @else {
    <app-contact-page
      [inquiry]="inquiry()"
      [messageError]="messageError()"
      [messageSending]="messageSending()"
      [messageSent]="messageSent()"
      [projects]="projects()"
      (fieldUpdated)="updateInquiry($event.field, $event.value)"
      (inquirySent)="sendInquiry()"
    />
  }

  @if (activePage() !== 'project') {
    <app-site-footer
      [projects]="projects()"
      (homeSectionSelected)="showHomeSection($event)"
      (inquiryRequested)="openInquiry(undefined, $event)"
      (pageSelected)="showPage($event)"
    />
  }

  @if (activePage() !== 'project') {
    <a
      class="whatsapp-float"
      href="https://wa.me/254700000000?text=Hello%20Pavillion%20Properties%2C%20I%20would%20like%20to%20inquire%20about%20your%20developments."
      target="_blank"
      rel="noopener"
      aria-label="Chat with Pavillion Properties on WhatsApp"
    >
      <svg aria-hidden="true" focusable="false" viewBox="0 0 32 32">
        <path
          d="M16.02 3.2A12.71 12.71 0 0 0 5.1 22.42L3.5 28.8l6.54-1.53A12.74 12.74 0 1 0 16.02 3.2Zm0 2.34a10.4 10.4 0 0 1 8.78 15.96 10.4 10.4 0 0 1-13.97 3.44l-.46-.27-3.65.85.9-3.55-.3-.48a10.38 10.38 0 0 1 8.7-15.95Zm-4.12 4.72c-.22 0-.58.08-.89.43-.3.35-1.17 1.14-1.17 2.78s1.2 3.23 1.36 3.45c.16.22 2.32 3.72 5.72 5.06 2.83 1.12 3.41.9 4.02.84.62-.06 1.99-.81 2.27-1.6.28-.78.28-1.46.2-1.6-.09-.14-.31-.22-.65-.39-.34-.17-1.99-.98-2.3-1.09-.31-.11-.54-.17-.76.17-.23.33-.87 1.09-1.06 1.31-.2.23-.39.25-.73.09-.34-.17-1.43-.53-2.72-1.68a10.2 10.2 0 0 1-1.88-2.34c-.2-.34-.02-.52.15-.69.15-.15.34-.39.5-.59.17-.2.23-.34.34-.56.11-.23.06-.42-.03-.59-.08-.17-.76-1.84-1.05-2.52-.27-.66-.55-.57-.76-.58h-.56Z"
        />
      </svg>
    </a>
  }

  @if (inquiryOpen()) {
    <app-inquiry-modal
      [inquiry]="inquiry()"
      [messageError]="messageError()"
      [messageSending]="messageSending()"
      [messageSent]="messageSent()"
      [projects]="projects()"
      (closed)="closeInquiry()"
      (fieldUpdated)="updateInquiry($event.field, $event.value)"
      (inquirySent)="sendInquiry()"
    />
  }
</main>
